import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class FmRoomGuard implements CanActivate {
  constructor(private readonly _router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return !!route.queryParams.participantToken || route.firstChild?.params?.participant
      ? true
      : this._router.createUrlTree(['/main']);
  }
}
